import { render, staticRenderFns } from "./commonSet.vue?vue&type=template&id=16200fc2&scoped=true"
import script from "./commonSet.vue?vue&type=script&lang=js"
export * from "./commonSet.vue?vue&type=script&lang=js"
import style0 from "./commonSet.vue?vue&type=style&index=0&id=16200fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16200fc2",
  null
  
)

export default component.exports